import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { useAuth, type IVerantosUser } from '@verantos-dev/core-annotation-tool';

const isAutomationUser = (user: IVerantosUser) => {
  return user.organizationName === 'QA Org' || user.email?.includes('platform-testing');
};

export const useSentry = () => {
  const { user } = useAuth();

  useEffect(() => {
    Sentry.setUser({ email: user.email });
    Sentry.setTag('organization', user.organizationName);
    const replay = Sentry.getReplay();

    if (!isAutomationUser(user)) {
      console.info(`Enabling Sentry replay for user ${user.email || 'unknown'}`);
      replay?.start();
    } else {
      console.info('Disabling Sentry replay for automation user');
      replay?.stop?.();
    }

    // Cleanup: stop replay when user changes or component unmounts
    return () => {
      replay?.stop?.();
    };
  }, [user]);
};
